export default {
  SosLog: "SosLog",
};
